function Tokelau({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2320)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M25.7391 7.65219C25.5956 8.34188 25.5304 9.07644 25.5304 9.80869C25.5304 14.0296 28.0466 17.6828 31.6526 19.3273C31.8796 18.2538 32 17.141 32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 24.8365 7.1635 32 16 32C21.4801 32 26.3161 29.2443 29.1998 25.0435H9.0435V22.9566H30.4124C30.6311 22.5043 30.8286 22.04 31.0049 21.5653H9.0435L25.7391 7.65219Z" fill="#0052B4"/>
  <path d="M11.7546 8.34766L12.0999 9.41053H13.2174L12.3134 10.0675L12.6587 11.1303L11.7546 10.4735L10.8505 11.1303L11.1958 10.0675L10.2916 9.41053H11.4092L11.7546 8.34766Z" fill="#F0F0F0"/>
  <path d="M7.21492 16L7.64667 17.3287H9.04354L7.91335 18.1496L8.3451 19.4783L7.21492 18.6571L6.08479 19.4783L6.51648 18.1496L5.38635 17.3287H6.78323L7.21492 16Z" fill="#F0F0F0"/>
  <path d="M7.21492 4.86914L7.64667 6.19783H9.04354L7.91335 7.01877L8.3451 8.34739L7.21492 7.52627L6.08479 8.34739L6.51648 7.01877L5.38635 6.19783H6.78323L7.21492 4.86914Z" fill="#F0F0F0"/>
  <path d="M3.73664 11.1299L4.16839 12.4586H5.56521L4.43508 13.2795L4.86683 14.6081L3.73664 13.787L2.60652 14.6081L3.03821 13.2795L1.90808 12.4586H3.30489L3.73664 11.1299Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Tokelau;
